import Vue from 'vue';
import {QuickOrderForm} from '../components/QuickOrderForm';

import '../../sass/components/_select.scss';


/**
 * var quotation_schema = JSON.parse('{"parcel_type": 1, "parcel_length": null, "parcel_width": null, "parcel_height": null, "parcel_weight": null, "parcel_count": null, "country_from": "PL", "country_to": "PL"}');
 * @param schema
 */
function getDefaultValueFromSchema(schema) {
    if (!schema) {
        return {};
    }
    
    const result = {
    
    };
    for (const key of Object.keys(schema)) {
        const value = schema[key];
        
        if (value === null || value === undefined) {
            continue;
        }
        
        switch (key) {
            case 'parcel_type':
                result.package_type = value;
                break;
                
            case 'parcel_length':
                result.length = value;
                break;
                
            case 'parcel_width':
                result.width = value;
                break;
                
            case 'parcel_height':
                result.height = value;
                break;
                
            case 'parcel_weight':
                result.weight = value;
                break;
                
            case 'parcel_count':
                result.count = value;
                break;
                
            case 'country_from':
                result.countryFrom = value;
                break;
                
            case 'country_to':
                result.countryTo = value;
                break;
        }
    }
    
    return result;
}

new Vue({
    el: '#quick-pricing',
    components: {QuickOrderForm},
    data() {
        return {
            defaultValue: getDefaultValueFromSchema(global.quotation_schema),
            type: 'widget'
        };
    }
});